module.exports = __webpack_public_path__ + "static/media/addDocService.45d2ecf8.png";